import { render, staticRenderFns } from "./CounterpartyDetails.vue?vue&type=template&id=92996f48&"
import script from "./CounterpartyDetails.vue?vue&type=script&lang=js&"
export * from "./CounterpartyDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports